import { render } from "./WordMatrix.vue?vue&type=template&id=7660e6e8&scoped=true"
import script from "./WordMatrix.vue?vue&type=script&lang=js"
export * from "./WordMatrix.vue?vue&type=script&lang=js"

import "./WordMatrix.vue?vue&type=style&index=0&id=7660e6e8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7660e6e8"]])

export default __exports__